import React, { createContext, useState, useMemo, ReactNode } from "react"
import { ThemeOptions, ThemeProvider } from "@mui/material/styles"
import lightTheme from "src/theme/light-theme"
import darkTheme from "src/theme/dark-theme"

interface ThemeContextType {
  toggleTheme: () => void
  mode: "light" | "dark"
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

interface ThemeContextProviderProps {
  children: ReactNode
}
const themeModes: { [key: string]: "light" | "dark" } = {
  light: "light",
  dark: "dark"
}
const themes: { [key: string]: ThemeOptions } = {
  light: lightTheme,
  dark: darkTheme
}
export const ThemeContextProvider: React.FC<ThemeContextProviderProps> = ({ children }) => {
  const defaultTheme = themeModes[(localStorage.getItem("theme") as "light" | "dark") ?? "light"] ?? "light"
  const [mode, setMode] = useState<"light" | "dark">(defaultTheme)

  const toggleTheme = () => {
    const newMode = mode === "light" ? "dark" : "light"
    localStorage.setItem("theme", newMode)
    setMode(newMode)
  }

  const theme = useMemo(() => themes[mode] ?? lightTheme, [mode])

  return (
    <ThemeContext.Provider value={{ toggleTheme, mode }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  )
}
